<template>
  <div class="c-form">
    <div class="c-form__wrap">
      <h2>Interesuje mnie</h2>
      <div class="c-form__wrap-flex">
        <template v-if="$route.params.url == 'jazda_testowa'">
          <label>
            <select v-if="config.uniqueBrands" v-model="input.prefered_brand" @change="input.prefered_model = ''">
              <option value="" disabled selected>MARKA</option>
              <option
                v-for="brand in config.uniqueBrands"
                :key="brand"
                :value="brand.name"
              >
                {{ brand.name }}
              </option>
            </select>
          </label>
          <MultiSelect
            v-if="config.modelsByBrandName"
            v-model="input.prefered_model"
            header="MODEL"
            :options="config.modelsByBrandName"
          />
          <!-- <label v-if="config.modelsByBrandName">
            <select v-model="input.prefered_model">
              <option value="" disabled selected>MODEL</option>
              <option
                v-for="model in config.modelsByBrandName"
                :key="model.id"
                :value="model.name"
              >
                {{ model.name }}
              </option>
            </select>
          </label> -->
        </template>
        <MultiSelect
          v-if="config.models"
          v-model="input.model"
          header="WYBIERZ MODEL"
          :options="config.models"
        />
        <label v-if="brand != 'MG'">
          <select v-if="config.months" v-model="input.month">
            <option value="" disabled selected>PLANOWANY ZAKUP</option>
            <option v-for="month in config.months" :key="month.id" :value="month.name">
              {{ month.name }}
            </option>
          </select>
        </label>
        <label>
          <select v-if="config.financing" v-model="input.financing">
            <option value="" disabled selected>FINANSOWANIE</option>
            <option v-for="elem in config.financing" :key="elem.id" :value="elem.name">
              {{ elem.name }}
            </option>
          </select>
        </label>
      </div>
      <div>
        <h3>Czy jesteś zainteresowany jazdą testową?</h3>
        <div>
          <label>
            <input type="radio" v-model="input.testRide" value="TAK" /> Tak
          </label>
          <label>
            <input type="radio" v-model="input.testRide" value="NIE" /> Nie
          </label>
        </div>
      </div>
      <div v-if="brand != 'MG'">
        <h3>Czy chcesz poznać naszą ofertę serwisową?</h3>
        <div>
          <label>
            <input type="radio" v-model="input.serviceOffer" value="TAK" /> Tak
          </label>
          <label>
            <input type="radio" v-model="input.serviceOffer" value="NIE" /> Nie
          </label>
        </div>
      </div>
      <div v-if="brand != 'MG'">
        <h3>Czy chcesz poznać naszą ofertę ubezpieczenia samochodu?</h3>
        <div>
          <label> <input type="radio" v-model="input.insurance" value="TAK" /> Tak </label>
          <label> <input type="radio" v-model="input.insurance" value="NIE" /> Nie </label>
        </div>
      </div>
      <template v-if="brand == 'audi'">
        <h3>Czy chcesz poznać ofertę oryginalnych akcesoriów Audi?</h3>
        <div>
          <label>
            <input type="radio" v-model="input.accesories" value="TAK" /> Tak
          </label>
          <label>
            <input type="radio" v-model="input.accesories" value="NIE" /> Nie
          </label>
        </div>
      </template>
      <template v-if="brand == 'volkswagen'">
        <h3>Czy chcesz poznać ofertę oryginalnych akcesoriów Volkswagena?</h3>
        <div>
          <label>
            <input type="radio" v-model="input.accesories" value="TAK" /> Tak
          </label>
          <label>
            <input type="radio" v-model="input.accesories" value="NIE" /> Nie
          </label>
        </div>
      </template>
      <template v-if="brand == 'skoda'">
        <h3>Czy chcesz poznać ofertę oryginalnych akcesoriów Skody?</h3>
        <div>
          <label>
            <input type="radio" v-model="input.accesories" value="TAK" /> Tak
          </label>
          <label>
            <input type="radio" v-model="input.accesories" value="NIE" /> Nie
          </label>
        </div>
      </template>
      <h2>Dane kontaktowe</h2>
      <div class="form__input">
        <Row>
          <label>
            <input type="text" placeholder="IMIĘ" v-model="input.first_name" required />
          </label>
          <label>
            <input
              type="text"
              placeholder="NAZWISKO"
              v-model="input.last_name"
              required
            />
          </label>
        </Row>
        <Row>
          <label>
            <input
              type="text"
              placeholder="ADRES E-MAIL"
              v-model="input.email"
              required
            />
          </label>
          <label>
            <input
              type="text"
              placeholder="NUMER TELEFONU"
              v-model="input.phone"
              required
            />
          </label>
        </Row>
        <Row>
          <label>
            <input
              type="text"
              placeholder="NAZWA AKCJI"
              v-model="input.action"
            />
          </label>
        </Row>
      </div>
      <div class="form__input" v-bind:class="{'text-center': !config.localization}">
        <Row>
          <label v-if="config.localization">
            <select v-bind:class="{'full-width': config.localization}" v-model="input.localization">
              <option value="" disabled selected>LOKALIZACJA</option>
              <option v-for="localization in config.localization" :key="localization.id" :value="localization.name">
                {{ localization.name }}
              </option>
            </select>
          </label>

          <label v-if="config.localizationByBrandName">
            <select v-bind:class="{'full-width': config.localizationByBrandName}" v-model="input.localization">
              <option value="" disabled selected>LOKALIZACJA</option>
              <option
                v-for="localization in config.localizationByBrandName"
                :key="localization.id"
                :value="localization.name"
              >
                {{ localization.name }}
              </option>
            </select>
          </label>

          <label>
            <select v-bind:class="{'full-width': config.localization || config.localizationByBrandName}" v-model="input.hour">
              <option value="" disabled selected>GODZINY KONTAKTU</option>
              <option :value="hour.name" v-for="hour in config.hours" :key="hour.id">
                {{ hour.name }}
              </option>
            </select>
          </label>
        </Row>
      </div>
      <label>
        <Row>
          <input
            type="checkbox"
            v-model="input.accept1"
            true-value="TAK"
            false-value=""
          />
          <div class="c-form__acceptText">
            Wyrażam zgodę na przetwarzanie przez {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].name 
              : formInfo['Maxus'].name 
            }} (KRS: {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].krs
              : formInfo['Maxus'].krs 
            }}) danych osobowych w zakresie: imienia,
            nazwiska, adresu poczty elektronicznej, numeru telefonu, adresu
            korespondencyjnego, w celach marketingowych. Podanie moich danych osobowych
            było dobrowolne i świadome. Poinformowano mnie o przysługujących mi prawach, w
            szczególności o prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność
            z prawem przetwarzania, którego dokonano na podstawie zgody przed jej
            wycofaniem. W ramach zgody możemy skontaktować się z Panią / Panem celem
            zaproszenia do kontaktu i zapoznania się z akcjami marketingowymi {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].name 
              : formInfo['Maxus'].name 
            }}, przykładowo z informacjami o
            konkursach, ofertach, promocjach, nowych modelach VW lub Audi, rabatach.
          </div>
        </Row>
      </label>
      <label>
        <Row>
          <input
            type="checkbox"
            v-model="input.accept2"
            true-value="TAK"
            false-value=""
          />
          <div class="c-form__acceptText">
            Wyrażam zgodę na przetwarzanie przez {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].name 
              : formInfo['Maxus'].name 
            }} (KRS: {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].krs
              : formInfo['Maxus'].krs 
            }}) danych osobowych w zakresie: imienia,
            nazwiska, adresu poczty elektronicznej, numeru telefonu, adresu
            korespondencyjnego, numeru i daty obowiązywania produktu finansowego, w celach
            marketingowych produktów finansowych, w tym leasing, kredyt, ubezpieczenie
            bądź pozostałe. Podanie moich danych osobowych było dobrowolne i świadome.
            Poinformowano mnie o przysługujących mi prawach, w szczególności o prawie
            cofnięcia zgody w każdym czasie, bez wpływu na zgodność z prawem
            przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. W
            ramach zgody możemy skontaktować się z Panią / Panem po zakupie pojazdu oraz
            przed upływem terminu wygaśnięcia produktu finansowego, w celu zapoznania z
            aktualna ofertą produktów finansowych.
          </div>
        </Row>
      </label>
      <label>
        <Row>
          <input
            type="checkbox"
            v-model="input.accept3"
            true-value="TAK"
            false-value=""
          />
          <div class="c-form__acceptText">
            Wyrażam zgodę na otrzymywanie drogą elektroniczną na wskazany adres poczty
            elektronicznej informacji marketingowych od {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].name 
              : formInfo['Maxus'].name 
            }} (KRS: {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].krs
              : formInfo['Maxus'].krs 
            }}). Podanie moich danych osobowych było
            dobrowolne i świadome. Poinformowano mnie o przysługujących mi prawach, w
            szczególności o prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność
            z prawem przetwarzania, którego dokonano na podstawie zgody przed jej
            wycofaniem. W ramach zgody możemy przesłać do Pani / Pana drogą elektroniczną
            informacje marketingową w zakresie działalności dealerskiej oraz działalności
            agenta ubezpieczeniowego.
          </div>
        </Row>
      </label>
      <label>
        <Row>
          <input
            type="checkbox"
            v-model="input.accept4"
            true-value="TAK"
            false-value=""
          />
          <div class="c-form__acceptText">
            Wyrażam zgodę na otrzymywanie drogą elektroniczną na wskazany adres poczty
            elektronicznej informacji handlowych od {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].name 
              : formInfo['Maxus'].name 
            }} (KRS: {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].krs
              : formInfo['Maxus'].krs 
            }}). Podanie moich danych osobowych było
            dobrowolne i świadome. Poinformowano mnie o przysługujących mi prawach, w
            szczególności o prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność
            z prawem przetwarzania, którego dokonano na podstawie zgody przed jej
            wycofaniem. W ramach zgody możemy przesłać do Pani / Pana drogą elektroniczną
            ofertę produktową w zakresie działalności dealerskiej oraz działalności agenta
            ubezpieczeniowego.
          </div>
        </Row>
      </label>
      <label>
        <Row>
          <input
            type="checkbox"
            v-model="input.accept5"
            true-value="TAK"
            false-value=""
          />
          <div class="c-form__acceptText">
            Wyrażam zgodę na wykorzystanie przez {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].name 
              : formInfo['Maxus'].name 
            }} (KRS: {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].krs
              : formInfo['Maxus'].krs 
            }}) numeru telefonu dla celów marketingu
            bezpośredniego towarów i usług. Podanie moich danych osobowych było dobrowolne
            i świadome. Poinformowano mnie o przysługujących mi prawach, w szczególności o
            prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność z prawem
            przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. W
            ramach zgody możemy podjąć z Panią / Panem kontakt w formie połączenia
            telefonicznego, wiadomości tekstowej lub/i multimedialnej.
          </div>
        </Row>
      </label>
      <label>
        <span v-if="errors.accept6" class="c-form__error">{{ errors.accept6 }}</span>
        <Row>
          <input
            type="checkbox"
            v-model="input.accept6"
            true-value="TAK"
            false-value=""
          />
          <div class="c-form__acceptText">
            Wyrażam zgodę na wykorzystanie przez {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].name 
              : formInfo['Maxus'].name 
            }} (KRS: {{ 
              $route.params.url != 'maxus' && $route.params.url != 'MG'
              ? formInfo['Krotoski'].krs
              : formInfo['Maxus'].krs 
            }}) numeru telefonu dla celów przekazywania
            informacji handlowej. Podanie moich danych osobowych było dobrowolne i
            świadome. Poinformowano mnie o przysługujących mi prawach, w szczególności o
            prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność z prawem
            przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. W
            ramach zgody możemy podjąć z Panią / Panem kontakt w formie połączenia
            telefonicznego, wiadomości tekstowej lub/i multimedialnej.
          </div>
        </Row>
      </label>
    </div>
    <div class="text-center" v-if="valid">
      <button v-on:click="$emit('submit', true)">wyślij</button>
    </div>
  </div>
</template>
<script>
import MultiSelect from './MultiSelect.vue'
import Row from "./Row.vue";
export default {
  components: {
    MultiSelect,
    Row,
  },
  props: ["config"],
  data() {
    return {
      input: {
        model: "",
        month: "",
        year: "",
        testRide: "",
        serviceOffer: "",
        insurance: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        hour: "",
        localization: "",
        financing: "",
        action: "",
        accept1: "",
        accept2: "",
        accept3: "",
        accept4: "",
        accept5: "",
        accept6: "",
        accesories: "NIE",
        prefered_brand: "",
        prefered_model: "",
      },
      required: {
        accept6: "wyraź zgodę",
      },
      formInfo: {
        'Krotoski': {
          name: 'Krotoski Spółka z ograniczoną odpowiedzialnością',
          krs: '0000946790'
        },
        'Maxus': {
          name: 'Krotoski ElectroMobility Sp. z o.o.',
          krs: '0000463723'
        }
      },
      errors: {},
      valid: false,
    };
  },
  computed: {
    brand() {
      return this.$route.params.url;
      // const brands = ["audi", "skoda", "volkswagen"];
      // return brands.find((b) => this.$route.params.url.includes(b));
    },
  },
  watch: {
    'input.prefered_brand': {
      handler() {
        this.input.localization = ''
      }
    },
    input: {
      handler() {
        Object.keys(this.required).map(
          (e) =>
            (this.errors[e] = ["", "NIE", null, false].includes(this.input[e])
              ? this.required[e]
              : false)
        );

        this.valid = !Object.values(this.errors).find((e) => e != false);

        this.$emit("typing", {
          ...this.input,
          valid: this.valid,
        });
      },
      deep: true,
    }
  },
};
</script>
<style lang="scss">
.c-form {
  max-width: 1630px;
  padding: 2rem;
  margin: 5rem auto;
  box-shadow: 7px 7px 17px 0px rgba(0, 0, 0, 0.15);
  &__wrap {
    max-width: 1250px;
    margin: 0 auto;

    &-flex {
      display: flex;
      align-items: center;
    }
  }
  &__acceptText {
    margin: 0rem 0 2rem 1rem;
  }
  &__error {
    color: #d00;
  }
}

.form__input{
  .c-row{
    @media(max-width: 960px){
      flex-wrap: wrap;
    }
  }
}
</style>
